/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import axios from "axios";
import ManualRequestForm from "./ManualRequestForm";
import API_BASE_URL from "./config";

export default function EmployeeAdvance() {
  const [advances, setAdvances]     = useState([]);
  const [records, setRecords]       = useState([]);
  const [loading, setLoading]       = useState(false);
  const [showManual, setShowManual] = useState(false);
  const [search, setSearch]         = useState("");
  const [startDate, setStart]       = useState("");
  const [endDate, setEnd]           = useState("");

  const fetchData = async () => {
    setLoading(true);
    try {
      const [pendingRes, recordsRes] = await Promise.all([
        axios.get(`${API_BASE_URL}/advance/pending`),
        axios.get(`${API_BASE_URL}/advance/records`),
      ]);
      setAdvances(pendingRes.data || []);
      setRecords(recordsRes.data || []);
    } catch (e) {
      console.error(e);
      alert("Error: " + (e?.response?.data?.message || e.message || "Operation failed."));
    }
    setLoading(false);
  };

  useEffect(() => { fetchData(); }, []);

  const handleApproval = async (id, status, requestedAmount) => {
    let approvedAmount = 0;
    if (status === "Approved") {
      const input = prompt(`Enter approved amount (max ₹${requestedAmount}):`);
      approvedAmount = parseFloat(input);
      if (isNaN(approvedAmount) || approvedAmount <= 0 || approvedAmount > requestedAmount) {
        alert(`Invalid amount. Must be > 0 and ≤ ₹${requestedAmount}`); return;
      }
    }
    try {
      await axios.put(`${API_BASE_URL}/advance/${id}`, { status, approvedAmount });
      fetchData();
    } catch (e) { alert("Action failed"); }
  };

  const filteredRecords = records.filter(r => {
    const q = search.toLowerCase();
    const matchSearch = (r.driverId || "").toLowerCase().includes(q) ||
                        (r.driverName || "").toLowerCase().includes(q);
    return matchSearch;
  });

  const downloadCSV = () => {
    const h = "Driver ID,Name,Month,Requested,Approved,Status\n";
    const rows = filteredRecords.map(r =>
      `${r.driverId},${r.driverName},${r.month},${r.requestedAmount},${r.approvedAmount || ""},${r.approvalStatus}`
    ).join("\n");
    const blob = new Blob([h + rows], { type: "text/csv" });
    const a = document.createElement("a"); a.href = URL.createObjectURL(blob);
    a.download = `advance_records.csv`; a.click();
  };

  const S = {
    container:  { fontFamily: "Arial, sans-serif", marginLeft: "270px", marginRight: "10px", backgroundColor: "#fff", color: "#000", minHeight: "100%", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" },
    toolbar:    { display: "flex", gap: 10, alignItems: "center", padding: "14px 16px", flexWrap: "wrap" },
    input:      { padding: "8px 10px", border: "1px solid #ccc", borderRadius: 5, fontSize: 13 },
    btnYellow:  { background: "#FFC107", color: "#000", border: "none", padding: "8px 16px", borderRadius: 5, cursor: "pointer", fontWeight: "bold", fontSize: 13 },
    btnBlack:   { background: "#000", color: "#fff", border: "none", padding: "8px 16px", borderRadius: 5, cursor: "pointer", fontWeight: "bold", fontSize: 13, minWidth: 80 },
    table:      { width: "100%", borderCollapse: "collapse", marginBottom: 24 },
    thB:        { background: "#000", color: "#fff", padding: "14px 12px", textAlign: "center", fontSize: 13, fontWeight: "bold" },
    td:         { border: "1px solid #ccc", padding: "10px 12px", textAlign: "center", fontSize: 13, color: "#000" },
    sectionLbl: { fontWeight: "bold", fontSize: 14, padding: "16px 16px 8px" },
  };

  const badgeStyle = (s) => ({
    background: s === "Approved" ? "#e6f9ee" : s === "Rejected" ? "#fde8e8" : "#fff8e1",
    color:      s === "Approved" ? "#27ae60" : s === "Rejected" ? "#c0392b" : "#d68910",
    padding: "3px 10px", borderRadius: 10, fontSize: 11, fontWeight: "bold",
  });

  return (
    <div style={S.container}>
      <h2 className="sendo-heading">Advance Requests</h2>

      <div style={S.toolbar}>
        <button style={S.btnBlack} onClick={() => setShowManual(!showManual)}>
          {showManual ? "✕ Close Form" : "✏ Manual Request"}
        </button>
        <input style={S.input} placeholder="Search driver..." value={search} onChange={e => setSearch(e.target.value)} />
        <input style={S.input} type="date" value={startDate} onChange={e => setStart(e.target.value)} />
        <input style={S.input} type="date" value={endDate}   onChange={e => setEnd(e.target.value)} />
        <button style={S.btnYellow} onClick={downloadCSV}>⬇ Download</button>
      </div>

      {showManual && <ManualRequestForm onClose={() => setShowManual(false)} onSaved={fetchData} />}

      {loading ? (
        <p style={{ padding: 20 }}>Loading...</p>
      ) : (
        <>
          {/* Pending */}
          <div style={S.sectionLbl}>Pending Advance Requests ({advances.length})</div>
          {advances.length === 0 ? (
            <p style={{ padding: "0 16px 16px", color: "#888", fontSize: 13 }}>No pending requests.</p>
          ) : (
            <div style={{ overflowX: "auto", padding: "0 16px" }}>
              <table style={S.table}>
                <thead>
                  <tr>
                    {["Driver ID","Driver Name","Month","Requested Amount","Action"].map(h => (
                      <th key={h} style={S.thB}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {advances.map((a, i) => (
                    <tr key={a._id} style={{ background: i % 2 === 0 ? "#fff" : "#f9f9f9" }}>
                      <td style={S.td}>{a.driverId}</td>
                      <td style={S.td}>{a.driverName}</td>
                      <td style={S.td}>{a.month}</td>
                      <td style={S.td}>₹{a.requestedAmount}</td>
                      <td style={S.td}>
                        <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
                          <button style={{ ...S.btnYellow, padding: "5px 10px" }}
                            onClick={() => handleApproval(a._id, "Approved", a.requestedAmount)}>Approve</button>
                          <button style={{ ...S.btnBlack, padding: "5px 10px" }}
                            onClick={() => handleApproval(a._id, "Rejected", a.requestedAmount)}>Reject</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Records */}
          {records.length > 0 && (
            <>
              <div style={S.sectionLbl}>Records ({filteredRecords.length})</div>
              <div style={{ overflowX: "auto", padding: "0 16px" }}>
                <table style={S.table}>
                  <thead>
                    <tr>
                      {["Driver ID","Driver Name","Month","Requested","Approved","Status"].map(h => (
                        <th key={h} style={S.thB}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {filteredRecords.map((r, i) => (
                      <tr key={r._id} style={{ background: i % 2 === 0 ? "#fff" : "#f9f9f9" }}>
                        <td style={S.td}>{r.driverId}</td>
                        <td style={S.td}>{r.driverName}</td>
                        <td style={S.td}>{r.month}</td>
                        <td style={S.td}>₹{r.requestedAmount}</td>
                        <td style={S.td}>{r.approvalStatus === "Approved" ? `₹${r.approvedAmount}` : "—"}</td>
                        <td style={S.td}><span style={badgeStyle(r.approvalStatus)}>{r.approvalStatus}</span></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}
